<template>
  <div class="columns is-vcentered is-mobile mx-0 bookmarks-toolbar">
    <div class="column">
      <b-field>
        <p class="control">
          <button
            class="button is-light is-stealth"
            :class="{'is-active is-primary': (defaultView == 'Compact')}"
            @click="setView('Compact')"
          >
            <b-icon
              icon="compress-arrows-alt"
              size="is-small"
            />
          </button>
        </p>
        <p class="control">
          <button
            class="button is-light is-stealth"
            :class="{'is-active is-primary': (defaultView == 'Regular')}"
            @click="setView('Regular')"
          >
            <b-icon
              icon="bars"
              size="is-small"
            />
          </button>
        </p>
        <p class="control">
          <button
            class="button is-light is-stealth"
            :class="{'is-active is-primary': (defaultView == 'Grid')}"
            @click="setView('Grid')"
          >
            <b-icon
              icon="grip-horizontal"
              size="is-small"
            />
          </button>
        </p>
      </b-field>
    </div>
    <div class="column">
      <div class="has-text-right">
        <span class="tag is-rounded is-info is-light">
          {{ metadata.totalCount }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BookmarksListToolbar',
    props: ['defaultView'],
    computed: {
      metadata() {
        return this.$store.state['bookmarks'].metadata
      },
    },
    methods: {
      setView(view) {
        this.$store.commit('setDefaultView', view)
      },
    }
  }
</script>
